import React, { Component, useState, useRef } from "react"
import Layout from "../components/layout"
import { FaQuoteLeft, FaQuoteRight, FaTags } from "react-icons/fa"
import {
  AiFillLinkedin,
  AiFillFacebook,
  AiFillInstagram,
  AiFillMail,
  AiFillPhone,
} from "react-icons/ai"
import { GatsbyImage } from "gatsby-plugin-image"
import "./testimonial.css"
import "../styles/slider.scss"
import { Link } from "gatsby"

export default function Testimonial({ pageContext }) {
  const {
    faqs,
    keywords,
    name,
    timeline,
    quote,
    displaypicture,
    contact,
    background_color,
    faq_color,
    branches,
    CGPA,
  } = pageContext

  const tags = keywords.map(a => a.label)

  return (
    <Layout>
      <div
        className="profile-container"
        style={{ backgroundColor: background_color }}
      >
        <div className="profile-wrapper">
          <GatsbyImage
            image={displaypicture.childImageSharp.gatsbyImageData}
            className="profile-image"
          />
          <div className="profile-content">
            <h1>Hello I'm</h1>
            <h1 className="profile-content-name">{name}</h1>
            <Typewriter
              toRotate={tags}
              period={1500}
              className="profile-content-type"
            />
          </div>
        </div>
      </div>
      {/* {branch.join(" & ")} */}
      <Quote quote={quote} contact={contact} color={background_color} />
      {branches ? (
        branches.map(a => (
          <h2 key={a.id} className="branch-names">
            {a.name}
          </h2>
        ))
      ) : (
        <></>
      )}
      {CGPA ? <h2 className="branch-names">CGPA: {CGPA}</h2> : <></>}
      <h1 className="section-headings">EXPERIENCE</h1>
      <Timeline data={timeline} color={background_color} />
      <h1 className="section-headings">QnA</h1>
      <FAQ data={faqs} color={faq_color} />
    </Layout>
  )
}

function Quote({ quote, contact, color }) {
  return (
    <div className="quote-container">
      {contact ? (
        <div className="contact" style={{ backgroundColor: color }}>
          {contact.linkedin ? (
            <a href={contact.linkedin} target="_blank">
              <AiFillLinkedin className="icon" />
            </a>
          ) : (
            <></>
          )}
          {contact.facebook ? (
            <a href={contact.facebook} target="_blank">
              <AiFillFacebook className="icon" />
            </a>
          ) : (
            <></>
          )}
          {contact.instagram ? (
            <Link href={contact.instagram} target="_blank">
              <AiFillInstagram className="icon" />
            </Link>
          ) : (
            <></>
          )}
          {contact.email ? (
            <Link href={`mailto:${contact.email}`} target="_blank">
              <AiFillMail className="icon" />
            </Link>
          ) : (
            <></>
          )}
          {contact.phone ? (
            <Link href={`tel:${contact.phone}`} target="_blank">
              <AiFillPhone className="icon" />
            </Link>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}

      <blockquote>
        <FaQuoteLeft className="quote-icon" />
        {quote}
        <FaQuoteRight className="quote-icon" />
      </blockquote>
    </div>
  )
}
function FAQ({ data, color }) {
  return (
    <div>
      {data.map(({ question, answer }) => (
        <div className="faq" style={{ backgroundColor: color }}>
          <Accordion title={question} content={answer} />
        </div>
      ))}
    </div>
  )
}

function Timeline({ data, color }) {
  return (
    <div className="timeline-container">
      {data.map(item => (
        <TimelineItem data={item} key={item.id} color={color} />
      ))}
    </div>
  )
}

function TimelineItem({ data, color }) {
  return (
    <div className="timeline-item">
      <div className="timeline-item-heading">
        <h3 className="timeline-period">{data.time_period}</h3>
        <h3 className="timeline-position">{data.company}</h3>
      </div>
      <div className="timeline-item-content">
        <h3 className="timeline-company">{data.position}</h3>
        <p className="timeline-desc">{data.description}</p>
      </div>
      <span className="circle" style={{ backgroundColor: color }}></span>
    </div>
  )
}
class Typewriter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      txt: "",
      fullTxt: "",
      loopNum: 0,
      isDeleting: false,
    }
  }

  componentDidMount() {
    this.tick()
  }

  componentDidUpdate(prevProps, prevState) {
    let delta = 100

    if (this.state.isDeleting) {
      delta /= 2
    }
    if (!this.state.isDeleting && this.state.txt === this.state.fullTxt) {
      delta = this.props.period
    } else if (this.state.isDeleting && this.state.txt === "") {
      delta = 500
    }

    setTimeout(() => this.tick(), delta)
  }

  tick() {
    let i = this.state.loopNum % this.props.toRotate.length

    let setFullTxt = this.props.toRotate[i]

    let copy = { ...this.state }

    if (this.state.isDeleting) {
      copy.txt = setFullTxt.substring(0, copy.txt.length - 1)
    } else {
      copy.txt = setFullTxt.substring(0, copy.txt.length + 1)
    }

    if (!this.state.isDeleting && this.state.txt === setFullTxt) {
      copy.isDeleting = true
    } else if (copy.isDeleting && this.state.txt === "") {
      copy.isDeleting = false

      copy.loopNum = copy.loopNum + 1
    }

    copy.fullTxt = setFullTxt

    this.setState(() => copy, console.log("delta", this.state.delta))
  }

  render() {
    return (
      <a className="typewrite">
        {this.state.txt}
        <span className="wrap"></span>{" "}
      </a>
    )
  }
}

function Accordion(props) {
  const [setActive, setActiveState] = useState("")
  const [setHeight, setHeightState] = useState("0px")
  const [setRotate, setRotateState] = useState("accordion__icon")

  const content = useRef(null)

  function toggleAccordion() {
    setActiveState(setActive === "" ? "active" : "")
    setHeightState(
      setActive === "active" ? "0px" : `${content.current.scrollHeight}px`
    )
    setRotateState(
      setActive === "active" ? "accordion__icon" : "accordion__icon rotate"
    )
  }

  return (
    <div className="accordion__section">
      <button className={`accordion ${setActive}`} onClick={toggleAccordion}>
        <p className="accordion__title">{props.title}</p>
        <Chevron className={`${setRotate}`} width={10} fill={"#777"} />
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="accordion__content"
      >
        <div
          className="accordion__text"
          dangerouslySetInnerHTML={{ __html: props.content }}
        />
      </div>
    </div>
  )
}
function Chevron(props) {
  return (
    <svg
      className={props.className}
      height={props.height}
      width={props.width}
      viewBox="0 0 266 438"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m258.476 235.971-194.344 194.343c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901l154.021-154.746-154.021-154.745c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0l194.343 194.343c9.373 9.372 9.373 24.568.001 33.941z"
        fill={props.fill}
      />
    </svg>
  )
}
